<template>
  <svg
    @click="$emit('click')"
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    version="1.1"
    :class="classes"
    :style="styles"
  >
    <path
      d="M13.3,12L23.7,1.5c0.3-0.3,0.3-0.9,0-1.3c-0.3-0.3-0.9-0.3-1.3,0L12,10.7L1.5,0.3c-0.3-0.3-0.9-0.3-1.3,0s-0.3,0.9,0,1.3 L10.7,12L0.3,22.5c-0.3,0.3-0.3,0.9,0,1.3C0.4,23.9,0.7,24,0.9,24s0.5-0.1,0.6-0.3L12,13.3l10.5,10.5c0.2,0.2,0.4,0.3,0.6,0.3 s0.5-0.1,0.6-0.3c0.3-0.3,0.3-0.9,0-1.3L13.3,12z"
    />
  </svg>
</template>

<script>
import BaseIcon from '@/components/icons/BaseIcon'

export default {
  extends: BaseIcon
}
</script>
